import React from 'react';

function FlagIcon(props) {
  const {
    color,
    ...otherProps
  } = props;

  const defaultColor = '#D0011B';

  return (
    <svg width="11" height="14" viewBox="0 0 11 14" xmlns="http://www.w3.org/2000/svg">
      <title>41AA3668-773D-4F3F-A321-27A29525157F</title>
      <path d="M1.486 3.23a2.54 2.54 0 0 1 2.54-1.57c.6 0 1.2 0 1.8-.07A2.57 2.57 0 0 0 8.296 0l.53 1.15c.63 1.37 1.26 2.74 1.88 4.11a.69.69 0 0 1 0 .52 2.57 2.57 0 0 1-2.4 1.34c-.77 0-1.55.06-2.32.14a2.29 2.29 0 0 0-1.79 1.13.57.57 0 0 0 0 .62c.59 1.23 1.17 2.46 1.75 3.7l.08.18a.77.77 0 0 1-.28 1 .75.75 0 0 1-1-.45l-3.52-7.46-.92-2a.75.75 0 1 1 1.18-.75z"
        fillRule="nonzero" fill={color || defaultColor}/>
    </svg>
  );
}

export default FlagIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/FlagIcon.js